import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Eyebrow, Reveal } from "./Reveal";

const TEXT =
  "Pleasure is not a brief, localised explosion that leaves you drained, numb, or searching for the next moment. Ecstasy is a continuous, living language — a baseline frequency that resides within your breath, your tissue, and your presence.";

const Word = ({ w, range, progress }) => {
  const color = useTransform(progress, range, ["#8F8176", "#F2E8DF"]);
  const gold = /ecstasy|living|breath,|tissue,|presence\./i.test(w);
  return (
    <motion.span style={{ color: gold ? undefined : color }} className={gold ? "italic text-[#D9B47A]" : ""}>
      {w}{" "}
    </motion.span>
  );
};

export default function Manifesto() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 80%", "end 45%"] });
  const words = TEXT.split(" ");
  return (
    <section ref={ref} data-testid="manifesto-section" className="relative max-w-[1440px] mx-auto px-5 sm:px-10 py-28 sm:py-44">
      <Reveal><Eyebrow n="I">What is possible</Eyebrow></Reveal>
      <p className="font-display mt-12 text-[clamp(1.9rem,4.4vw,4.4rem)] leading-[1.12] tracking-[-0.01em] max-w-[1200px]">
        {words.map((w, i) => (
          <Word key={i} w={w} progress={scrollYProgress} range={[i / words.length, (i + 1) / words.length]} />
        ))}
      </p>
      <Reveal delay={0.1} className="mt-16 grid sm:grid-cols-3 gap-10 max-w-4xl ml-auto">
        {[
          ["13", "Gates to Ecstasy, from Root Resonance to Embodied Enlightenment"],
          ["IV", "Volumes in the sacred series of The Tantric Temple"],
          ["∞", "A continuous baseline of bliss, lived daily"],
        ].map(([n, t]) => (
          <div key={n} className="border-t border-[#D9B47A]/25 pt-6">
            <div className="font-display text-5xl text-[#D9B47A]">{n}</div>
            <p className="mt-3 text-sm text-[#A8998C] leading-relaxed">{t}</p>
          </div>
        ))}
      </Reveal>
    </section>
  );
}
